<template>
  <v-dialog v-model="dialog" persistent width="50vw">
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="isNewAINarrative"
        color="primary"
        v-on="on"
        @click="dialog = true"
        >Start AI Narrative</v-btn
      >

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            v-if="!isNewAINarrative"
            small
            class="ml-2"
            v-on="on"
            @click="dialog = true"
            >mdi-pencil</v-icon
          >
        </template>
        <span>Edit Details</span>
      </v-tooltip>
    </template>

    <v-card v-if="dialog">
      <validation-observer ref="form" v-slot="{ invalid }">
        <v-card-title> AI Narrative </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="px-6">
          <v-text-field
            v-model="description"
            label="Description"
          ></v-text-field>

          <v-textarea
            v-model="instructions"
            label="Instructions"
            outlined
          ></v-textarea>

          <v-row class="justify-start">
            <v-col cols="4">
              <validation-provider rules="required|numeric" v-slot="{ errors }">
                <v-text-field
                  v-model="minWords"
                  label="Min Words"
                  type="number"
                  :error-messages="errors"
                ></v-text-field>
              </validation-provider>
            </v-col>
            <v-col cols="4">
              <validation-provider rules="required|numeric" v-slot="{ errors }">
                <v-text-field
                  v-model="maxWords"
                  label="Max Words"
                  type="number"
                  :error-messages="errors"
                ></v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="clear"> Cancel </v-btn>
          <v-btn color="primary" text :disabled="invalid" @click="save">
            Save
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["isNewAINarrative", "aiNarrative"],
  data() {
    return {
      dialog: false,
      description: this.aiNarrative?.description || "",
      instructions: this.aiNarrative?.instructions || "",
      minWords: this.aiNarrative?.minWords || "",
      maxWords: this.aiNarrative?.maxWords || "",
    };
  },
  computed: {
    templateId: function () {
      return this.$store.getters["templatesModule/getSelectedTemplateId"];
    },
  },
  methods: {
    save: async function () {
      this.dialog = false;
      this.$store.commit("uxModule/setShowLoader", true);
      let success = false;
      if (this.isNewAINarrative) {
        success = await this.$store.dispatch("templatesModule/addAINarrative", {
          templateId: this.templateId,
          description: this.description,
          instructions: this.instructions,
          minWords: this.minWords,
          maxWords: this.maxWords,
        });
      } else {
        success = await this.$store.dispatch(
          "templatesModule/updateAINarrative",
          {
            aiNarrativeId: this.aiNarrative.aiNarrativeId,
            templateId: this.templateId,
            description: this.description,
            instructions: this.instructions,
            minWords: this.minWords,
            maxWords: this.maxWords,
          }
        );
      }
      this.$store.commit("uxModule/setShowLoader", false);

      if (!success) {
        this.$store.commit("uxModule/setSnackbarMsg", "Error saving narrative");
        this.$store.commit("uxModule/setShowSnackbar", true);
      }

      this.clear();
    },
    clear: function () {
      this.$refs.form.reset();
      this.dialog = false;
      this.description = this.aiNarrative?.description || "";
      this.instructions = this.aiNarrative?.instructions || "";
      this.minWords = this.aiNarrative?.minWords || "";
      this.maxWords = this.aiNarrative?.maxWords || "";
    },
  },
};
</script>
